import React, {useEffect, useState} from 'react';
import "./SingleEvent.scss";
import {useParams} from "react-router-dom";
import EventsApi from "../../../api/EventsApi";
import {getAlbumPath} from "../../../tools/formatter";
import DiaryWrapper from "../DiaryWrapper";
import ReactImageGallery from "../../../components/ReactImageGallery/ReactImageGallery";

function SingleEvent(props) {
    const { userId, eventId } = useParams();
    const [currentEvent, setCurrentEvent] = useState([]);
    let content = "Single Event";

    useEffect(() => {
        console.log('componentdidmount single event');
        if ( userId && eventId) {
            EventsApi.getUserEvent(userId, eventId).then(response => {
                setCurrentEvent(response.event);
            } ).catch(error => {
                //TODO catch
            });
        }
    }, [userId, eventId]);

    if (currentEvent) {
        content = <div>
            <div className={"album-block"} >
                <ReactImageGallery path={getAlbumPath(currentEvent)} />
            </div>
        </div>;
    }

    return <DiaryWrapper additionalClassName={'EventsByDay'}>{content}</DiaryWrapper>
}

export default SingleEvent;
